import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';

export default function FilterButton(props) {
   const [value, setValue] = useState(false);

   useEffect(() => {
      setValue(props.value || false)
   }, [props.value])

   function onChange(checked) {
      const filteredDisplay = checked
         ? props.displayName
         : '';
      props.onChangeCallback({
         filterName: props.filterName,
         value: checked ? true : null,
         filteredDisplay,
      });
      ;
   }

   return (
      <Button
         children={props.displayName}
         className="filter-button"
         onClick={() => onChange(!value)}
         active={value}
         disabled={props.disabled}
      />
   );
}